export const grades = [
    "5th Grade" ,
    "6th Grade" ,
    "7th Grade" ,
    "8th Grade" ,
    "9th Grade" ,
    "10th Grade" ,
    "11th Grade" ,
    "12th Grade" ,
    "Compititive Exams" ,
    "Other"
  ];
export const  fields = ["Engineering" ,  "Management" , "Medical" , "Arts & Science","Commerce" , "Law" ,"Other"]

export const medMajor = ["PreClinical" , "ParaClinical" , "Clinical" , "Dentistry" , "Other" ]

export const engSubjects = ["Computer Science Engineering" , "Machanical Engineering" , "Electrical Engineering" , "Chemical Engineering" , "Civil Engineering" , "Aeronautical Engineering" , "Electronics" , "Biotechnology" , "Environmental Engineering" , "Industrial Engineering" , "Nuclear Engineering" , "Other"];
export const schoolSubjects = ["Physics" , "Chemistry" , "Biology" , "Maths" , "Social Studies", "Science" , "Computer Science" , "Other" ]
export const PreClinical = ["Anatomy" , "BioChemistry" , "Physiology" ,"Other"]
export const ParaClinical = ["Forensic medicine & toxicology" , "microbiology" , "pathology" , "pharmacology" , "Other"]
export const Clinical = ["Anaesthesiology" , "Community medicine" ,"Dermatology & Venereology" , "Gereral Medicine" , "Obstetrics & Gynaecology" , "Opthamalogy" , "Orthopaedics" ,"ENT" ,"Pediatrics" ,"Psychiatry" , "Surgery" , "Radio diagnosis" , "Other"]
export const Dentistry = ["Dental Materials" , "Oral Medicine & Radiology" ,"General anatomy,embryology & histology" ,"Orthodontics & dentofacial orthopedics" , "Other"]
